__turbopack_context__.v({
  "actionFavorite": "ActionFavorite-module-scss-module__nmLx2a__actionFavorite",
  "inner": "ActionFavorite-module-scss-module__nmLx2a__inner",
  "innerWithBackground": "ActionFavorite-module-scss-module__nmLx2a__innerWithBackground",
});
